import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { configActions } from '../../redux/actions';
import { getChangeLog } from '../../services/changelog';
import T from '../i18n/i18n';
import { Background, Button, ButtonBar, Header, HeaderTitle, Page, PageContent, PageText, PageTitle, Window, PageGroup } from './Changelog.styles';


export default (props) => {
    
    const [loaded, setLoaded] = useState(false);
    const [logs, setLogs] = useState([]);

    const opened = useSelector(state => state.configState.viewChangeLog);
    const lang = useSelector(state => state.configState.lang);
    const dispatch = useDispatch();

    useEffect(() => {
        (async () => {
            if (!loaded && opened) {
                let logs = await getChangeLog();
                setLogs(logs || []);
                setLoaded(true);
            }
        })();
    }, [opened, loaded]);
    
    const close = () => {
        dispatch(configActions.viewChangelog(false));
    }

    return <>
        <Background className={opened ? 'opened' : ''} />
        <Window className={opened ? 'opened' : ''}>
            <Header>
                <HeaderTitle><T value={"changelog.title"}/></HeaderTitle>
            </Header>
            <Page>
                <PageContent className={"scrollbar"}>
                    {logs && logs.length ? logs.map(log => <PageGroup key={log.version}>
                        <PageTitle>{log.version} <span>{log.date}</span></PageTitle>
                        {log.log[lang] && log.log[lang].length && log.log[lang].map((item, index) => <PageText key={index}>{item}</PageText>)}
                    </PageGroup>) : null}
                </PageContent>
            </Page>
            <ButtonBar>
                <Button color={"#999"} onClick={() => {close()}}><T value="close" /></Button>
                <div style={{flex: 1}}></div>
            </ButtonBar>
        </Window>
    </>;

};